/**
 * Altar del Perfume — collection filter panel.
 *
 * On desktop the panel is a permanent sidebar. Below 1000px the reference collapses it behind
 * a "Filtros y orden" button (/inspiration/Catalog  inspo/Mobile catalog 1.png), because a
 * stacked sidebar would push the products off the first screen.
 *
 * Progressive enhancement: the toggle is hidden until this runs, so with scripting off the
 * panel simply stays visible and the form still works.
 */
class AltarFilters extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-altar-filter-panel]');
    this.toggle = this.querySelector('[data-altar-filter-toggle]');
    if (!this.panel || !this.toggle) return;

    this.mq = window.matchMedia('(max-width: 999px)');
    this.toggle.hidden = false;

    this.onToggle = () => {
      const open = this.toggle.getAttribute('aria-expanded') === 'true';
      this.setOpen(!open);
    };

    this.onBreakpoint = () => this.sync();

    this.toggle.addEventListener('click', this.onToggle);
    this.mq.addEventListener('change', this.onBreakpoint);
    this.sync();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
    this.mq?.removeEventListener('change', this.onBreakpoint);
  }

  /** Above the breakpoint the panel is always shown and the toggle is irrelevant. */
  sync() {
    if (this.mq.matches) {
      this.setOpen(false);
    } else {
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  setOpen(open) {
    this.panel.hidden = !open;
    this.toggle.setAttribute('aria-expanded', String(open));
  }
}

if (!customElements.get('altar-filters')) {
  customElements.define('altar-filters', AltarFilters);
}
